import apiClient from "../../app/apiClient";

export async function listCallbackRequests() {
  const { data } = await apiClient.get("/admin/callback");
  const records = Array.isArray(data) ? data : data?.content ?? data?.data;
  if (!Array.isArray(records) || records.some((record) => !record || typeof record !== "object")) {
    throw new Error("The server returned an invalid callback request list.");
  }
  return records.map((record) => {
    const createdAt = record.createdAt ?? record.createDate ?? record.createdDate;
    const timestamp = createdAt ? Date.parse(createdAt) : NaN;
    return { ...record, isContacted: record.isContacted === true, createdAt, timestamp: Number.isFinite(timestamp) ? timestamp : null };
  }).sort((a, b) => (b.timestamp ?? -Infinity) - (a.timestamp ?? -Infinity));
}

// Proposed backend contract; see docs/callback-requests-api.md.
export function setCallbackContacted(id, isContacted) {
  if (id == null) throw new Error("This request has no ID and cannot be updated.");
  if (typeof isContacted !== "boolean") throw new Error("Contacted must be a boolean.");
  return apiClient.patch(`/admin/callback/${encodeURIComponent(id)}/status`, { isContacted });
}
